// src/components/Pages/arcade/ArcadeAssetState.tsx
import React from "react";
var ArcadeLoading = () => /* @__PURE__ */ React.createElement(
  "div",
  {
    role: "status",
    "aria-live": "polite",
    className: "flex h-full w-full items-center justify-center bg-black text-sm font-medium text-white"
  },
  "Loading game\u2026"
);
var ArcadeAssetError = ({
  title = "This game's images couldn't be loaded",
  detail = "Check your connection and reopen this page. If it keeps happening, the page's image links may need updating."
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    role: "alert",
    className: "flex h-full w-full items-center justify-center bg-black p-6"
  },
  /* @__PURE__ */ React.createElement("div", { className: "max-w-xs text-center" }, /* @__PURE__ */ React.createElement("div", { className: "mb-2 text-3xl", "aria-hidden": "true" }, "\u{1F5BC}\uFE0F"), /* @__PURE__ */ React.createElement("p", { className: "text-sm font-semibold text-white" }, title), /* @__PURE__ */ React.createElement("p", { className: "mt-1 text-xs text-white/70" }, detail))
);

export {
  ArcadeLoading,
  ArcadeAssetError
};
//# sourceMappingURL=chunk-NYFW62XT.mjs.map